export default __webpack_public_path__ + "static/media/S__61292581.9dcbb7f9.png";